import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useProperty } from "@/contexts/PropertyContext";
import { PageHeader } from "@/components/PageHelpers";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { BadgeCheck } from "lucide-react";

export default function IdVerificationsPage() {
  const { propertyId } = useProperty();
  const [items, setItems] = useState([]);
  const load = async () => {
    const { data } = await api.get(`/approvals?property_id=${propertyId}`);
    setItems(data.items.filter((a) => a.type === "id_verification"));
  };
  useEffect(() => { if (propertyId) load(); }, [propertyId]);
  const decide = async (id, decision) => { await api.patch(`/approvals/${id}/decide`, { decision }); toast.success("Recorded"); load(); };
  return (
    <div>
      <PageHeader eyebrow="Admin Tools" title="ID Verifications" subtitle="New residents awaiting identity verification." />
      <div className="space-y-3">
        {items.map((a) => (
          <Card key={a.id} className="border-white/10 bg-card p-5">
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-start gap-3">
                <div className="h-10 w-10 rounded-md bg-indigo-500/10 border border-indigo-500/30 flex items-center justify-center">
                  <BadgeCheck className="h-5 w-5 text-indigo-400" />
                </div>
                <div>
                  <div className="font-medium">{a.subject}</div>
                  <div className="text-xs text-zinc-500 mt-1">{new Date(a.submitted_at).toLocaleString()}</div>
                </div>
              </div>
              <Badge variant="outline" className="border-white/10 capitalize">{a.status}</Badge>
            </div>
            {a.status === "pending" && (
              <div className="mt-4 flex gap-2">
                <Button size="sm" onClick={() => decide(a.id, "approved")} className="bg-emerald-600 hover:bg-emerald-700">Verify</Button>
                <Button size="sm" variant="outline" onClick={() => decide(a.id, "denied")} className="border-rose-500/40 text-rose-300">Reject</Button>
              </div>
            )}
          </Card>
        ))}
        {items.length === 0 && <div className="text-sm text-muted-foreground">No ID verifications pending.</div>}
      </div>
    </div>
  );
}
